<template>
  <div>
    <div style="background: white; width: 100%; height: 100%; padding-top: 10px; overflow: auto">
      <div style="width: 1000px; margin: 0 auto; border: 1px solid black">
        <div v-for="(module, i) of moduleList" :key="i">
          <div style="display: flex; flex-direction: column">
            <!--业务名-->
            <div class="answer-list">
              <div class="answer-list-left">业务名:</div>
              <div class="answer-list-right">{{ module.modName }}</div>
            </div>
            <!--业务说明-->
            <div class="answer-list" style="height: 45px">
              <div class="answer-list-left">业务说明:</div>
              <div class="answer-list-right">{{ module.remark }}</div>
            </div>
            <!--背景单据-->
            <div class="answer-list" style="height: 45px">
              <div class="answer-list-left">背景单据:</div>
              <div class="answer-list-right">
                <div v-for="(bgData, bgIndex) of module.bgData" :key="bgIndex">
                  <button @click="bgBtnClick(bgData)">{{ bgData.bgName }}</button>&nbsp;&nbsp;
                </div>
              </div>
            </div>
            <!--学员答案-->
            <div class="answer-list" style="height: 45px">
              <div class="answer-list-left">学员答案:</div>
              <div class="answer-list-right">
                <button @click="studentAnswer(module)">点击查看学员答案</button>
              </div>
            </div>
          </div>
          <!--正确答案-->
          <div style="display: flex; flex-direction: column; border-bottom: 1px solid black">
            <div class="answer-list">
              <div class="answer-list-left">正确答案:</div>
              <div class="answer-list-right">
                <button @click="rightAnswer(module)">点击查看正确答案</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <a-modal
      :title="modalTitle"
      :visible="visible"
      :footer="null"
      @cancel="handleCancel"
      width="1300px"
      :centered="true"
    >
      <div class="normal" v-if="needData.modType === '1' || needData.modType === '8'">
        <div class="main-cont">
          <div class="cont-invoice" :class="rightList.taxClass == 0 ? 'zy' : rightList.taxClass == 1 ? 'pt' : 'dz'">
            <div
              class="invoice-header"
              :style="{ left: rightList.taxClass == 0 || rightList.taxClass == 1 ? '444px' : '388px' }"
            >
              <span>{{ needData.domainName }}</span>
            </div>
            <div class="invoice-no">
              <div class="version"><span>税收分类编码版本号:39.0</span></div>
              <div>
                <select name="" id="" class="code">
                  <option value="1">{{ rightList.taxBillCode }}</option>
                </select>
                <select name="" id="" class="number">
                  <option value="1">{{ rightList.taxBillNo }}</option>
                </select>
                <div class="date">
                  <span>{{ rightList.taxBillDate }}</span>
                </div>
              </div>
            </div>
            <div class="invoice-buyer">
              <div class="left">
                <div class="relative" :class="{ error: rightList.errBuyerName == '1' }">
                  <input type="text" :value="rightList.buyerName" />
                </div>
                <div class="relative" :class="{ error: rightList.errBuyerTaxpayerId == '1' }">
                  <input type="text" :value="rightList.buyerTaxpayerId" />
                </div>
                <div class="relative" :class="{ error: rightList.errBuyerAddress == '1' }">
                  <input type="text" :value="rightList.buyerAddress" />
                </div>
                <div class="relative" :class="{ error: rightList.errBuyerAccounts == '1' }">
                  <input type="text" :value="rightList.buyerAccounts" />
                </div>
              </div>
              <div class="right">
                <!-- <span
                  >4+-087430/*03-/53442005562-+556656+--- --+4566--64554663165125+*-00022+--8*+-5+
                  5125+*-00022+--8*+-5+55/5/56546-+430/*0- 546-+430/*03-/5344200>47>2++5/56546/+++-</span
                > -->
              </div>
            </div>
            <div class="invoice-table" style="min-height: 189px">
              <div class="table-header tab">
                <div style="flex: 3">货物或应税劳务、服务名称</div>
                <div style="flex: 1">规格型号</div>
                <div style="flex: 1">单位</div>
                <div style="flex: 1">数量</div>
                <div style="flex: 1.5">单价(不含税)</div>
                <div style="flex: 1.5">金额(不含税)</div>
                <div style="flex: 1">税率</div>
                <div style="flex: 1">税额</div>
              </div>
              <div class="table-content tab" v-for="(data, i) in bList" :key="i">
                <div style="flex: 3">
                  <div class="relative" :class="{ error: data.errGoodsName == '1' }">
                    <input
                      type="text"
                      :value="data.goodsCodeName + '*' + data.goodsName"
                      readonly
                      v-if="data.goodsCodeName && data.goodsCodeName !== 'null'"
                    />
                    <input type="text" :value="data.goodsName + '*' + data.goodsName" readonly v-else />
                  </div>
                </div>
                <div style="flex: 1" :class="{ error: data.errGoodsGauge == '1' }">
                  <input type="text" :value="data.goodsGauge" readonly />
                </div>
                <div style="flex: 1" :class="{ error: data.errGoodsUnits == '1' }">
                  <input type="text" :value="data.goodsUnits" readonly />
                </div>
                <div style="flex: 1" :class="{ error: data.errGoodsAmount == '1' }">
                  <input type="number" :value="data.goodsAmounts" readonly />
                </div>
                <div style="flex: 1.5" :class="{ error: data.errGoodsUnitPrice == '1' }">
                  <input type="number" :value="data.goodsUnitPrice" readonly />
                </div>
                <div style="flex: 1.5" :class="{ error: data.errGoodsPriceAmount == '1' }">
                  <input type="number" :value="data.goodsPriceAmounts" readonly />
                </div>
                <div style="flex: 1" :class="{ error: data.errGoodsTaxRate == '1' }">
                  <select :value="data.goodsTaxRates" disabled>
                    <option value="0">不征税</option>
                    <option value="0.00">0%</option>
                    <option value="0.03">3%</option>
                    <option value="0.05">5%</option>
                    <option value="0.015">按减1.5%计算</option>
                    <option value="0.09">9%</option>
                    <option value="0.11">11%</option>
                    <option value="0.13">13%</option>
                    <option value="0.16">16%</option>
                    <option value="0.17">17%</option>
                  </select>
                </div>
                <div style="flex: 1" :class="{ error: data.errTaxAmountPayable == '1' }">
                  <input type="text" :value="data.taxAmountPayables" readonly />
                </div>
              </div>
            </div>
            <div class="invoice-sum">
              <span style="margin-left: 637px" :class="{ error: rightList.errTotalGoodsPrice == '1' }">{{
                rightList.totalGoodsPrices
              }}</span>
              <span
                style="position: absolute; left: 825px; top: 447px"
                :class="{ error: rightList.errTotalTaxPay == '1' }"
                >{{ rightList.totalTaxPays }}</span
              >
            </div>
            <div class="invoice-taxsum">
              <span style="position: absolute; left: 356px; top: 469px">{{ allMoney | filterMoney }}</span>
              <span style="position: absolute; left: 876px; top: 469px">{{ allMoney }}</span>
            </div>
            <div class="invoice-saler">
              <div class="left">
                <input type="text" :value="rightList.enterpriseName" />
                <input type="text" :value="rightList.enterpriseTaxpayerId" />
                <input type="text" :value="rightList.enterpriseAddress" />
                <input type="text" :value="rightList.enterpriseAccounts" />
              </div>
              <div class="right">
                <textarea :value="rightList.remark" placeholder="请输入备注信息"></textarea>
              </div>
            </div>
            <div class="invoice-footer">
              <div class="payee"><input type="text" :value="rightList.payee" /></div>
              <div class="review"><input type="text" :value="rightList.rechecker" /></div>
              <div class="billing">{{ rightList.drawer }}</div>
            </div>
          </div>
          <div class="cont-op"></div>
        </div>
      </div>
      <div class="special" v-if="needData.modType === '7'">
        <div class="main-cont">
          <div class="cont-invoice">
            <div class="invoice-header"></div>
            <div class="invoice-no">
              <div>
                <div class="date">
                  <span>{{ invoiceData.taxBillDate }}</span>
                </div>
                <div class="applyer" :class="{ error: invoiceData.errBuyerName == '1' }">
                  {{ invoiceData.buyerName }}
                </div>
                <div class="number">{{ invoiceData.tabPipeNum }}</div>
              </div>
            </div>
            <div class="invoice-buyer">
              <div class="left">
                <div class="enterpriseName">
                  <input type="text" :value="invoiceData.enterpriseName" />
                </div>
                <div class="enterpriseTaxPayerId">
                  <input type="text" :value="invoiceData.enterpriseTaxPayerId" />
                </div>
              </div>
              <div class="right">
                <span class="buyerName" :class="{ error: invoiceData.errBuyerName == '1' }">{{
                  invoiceData.buyerName
                }}</span>
                <span class="buyerTaxPayerId" :class="{ error: invoiceData.errBuyerTaxpayerId == '1' }">{{
                  invoiceData.buyerTaxPayerId
                }}</span>
              </div>
            </div>
            <div class="invoice-table">
              <div class="table-header tab">
                <div style="flex: 3">货物或应税劳务、服务名称</div>
                <div style="flex: 1">规格型号</div>
                <div style="flex: 1">单位</div>
                <div style="flex: 1">数量</div>
                <div style="flex: 1.5">单价(不含税)</div>
                <div style="flex: 1.5">金额(不含税)</div>
                <div style="flex: 1">税率</div>
                <div style="flex: 1">税额</div>
              </div>
              <div class="table-content tab" v-for="(data, i) in bList" :key="i">
                <div style="flex: 3">
                  <div class="relative">
                    <input type="text" :value="data.goodsName" readonly :class="{ error: data.errGoodsName == '1' }" />
                  </div>
                </div>
                <div style="flex: 1">
                  <input type="text" :value="data.goodsGauge" readonly :class="{ error: data.errGoodsGauge == '1' }" />
                </div>
                <div style="flex: 1">
                  <input type="text" :value="data.goodsUnits" readonly :class="{ error: data.errGoodsUnits == '1' }" />
                </div>
                <div style="flex: 1">
                  <input
                    type="number"
                    :value="data.goodsAmounts"
                    readonly
                    :class="{ error: invoiceData.errGoodsAmount == '1' }"
                  />
                </div>
                <div style="flex: 1.5">
                  <input
                    type="number"
                    :value="data.goodsUnitPrice"
                    readonly
                    :class="{ error: invoiceData.errGoodsUnitPrice == '1' }"
                  />
                </div>
                <div style="flex: 1.5">
                  <input
                    type="number"
                    :value="data.goodsPriceAmounts"
                    readonly
                    :class="{ error: invoiceData.errGoodsPriceAmount == '1' }"
                  />
                </div>
                <div style="flex: 1">
                  <select :value="data.goodsTaxRates" disabled :class="{ error: invoiceData.errGoodsTaxRate == '1' }">
                    <option value="0">不征税</option>
                    <option value="0.00">0%</option>
                    <option value="0.03">3%</option>
                    <option value="0.05">5%</option>
                    <option value="0.015">按减1.5%计算</option>
                    <option value="0.09">9%</option>
                    <option value="0.11">11%</option>
                    <option value="0.13">13%</option>
                    <option value="0.16">16%</option>
                    <option value="0.17">17%</option>
                  </select>
                </div>
                <div style="flex: 1">
                  <input
                    type="text"
                    :value="data.taxAmountPayables"
                    readonly
                    :class="{ error: invoiceData.errTaxAmountPayable == '1' }"
                  />
                </div>
              </div>
            </div>
            <div class="invoice-sum">
              <span
                style="position: absolute; left: 160px; top: 7px"
                :class="{ error: invoiceData.errTotalGoodsPrice == '1' }"
              >
                ￥{{ invoiceData.totalGoodsPrices }}</span
              >
              <span
                style="position: absolute; left: 396px; top: 7px"
                :class="{ error: invoiceData.errTotalTaxPay == '1' }"
                >￥{{ invoiceData.totalTaxPays }}</span
              >
            </div>
            <div class="invoice-saler">
              <div class="left">
                <a-radio-group :value="invoiceData.apply">
                  <a-radio value="0" style="display: block">
                    一、购买方申请
                    <a-radio-group
                      :value="invoiceData.apply === '1' ? '' : invoiceData.deduction"
                      disabled
                      style="display: block; margin-left: 20%"
                    >
                      <span>对应蓝字增值税专用发票抵扣增值税销项税额情况</span>
                      <a-radio value="0" style="display: block"> 1、已抵扣 </a-radio>
                      <a-radio value="1"> 2、未抵扣</a-radio>
                    </a-radio-group>
                  </a-radio>
                  <a-radio value="1"> 二、销售方申请 </a-radio>
                </a-radio-group>
              </div>
              <div class="right">
                <div>对应蓝字专用发票密码区内打印的发票信息</div>
                <div>{{ invoiceData.taxBillCode }}</div>
                <div>{{ invoiceData.taxBillNo }}</div>
                <div>增值税专用发票</div>
              </div>
            </div>
          </div>
          <div class="cont-op"></div>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import Urls from '@/utils/globel.js'
import { changeNumMoneyToChinese, parseParam } from '@/utils/util.js'
export default {
  data() {
    return {
      moduleList: [],
      needData: { moduleId: '', modType: '', domainName: '' },
      //
      modalTitle: '',
      enterprise: {},
      kpdate: [],
      kpList: [],
      invoiceData: {},
      rightList: {},
      bList: [],
      allMoney: '',
      visible: false,
    }
  },
  filters: {
    filterMoney(money) {
      return changeNumMoneyToChinese(money)
    },
  },
  created() {
    this.getModuleList()
  },
  methods: {
    async getModuleList() {
      // if (Utils.getUserInfo(Utils.getUidForHref()) == undefined || Utils.getUserInfo(Utils.getUidForHref()) == null) {
      //   return
      // }
      const params = parseParam()
      const res = await this.$http.post(`${Urls.getModuleList}&${params}`)
      if (res) {
        this.moduleList = res.data
        this.needData.domainName = res.domainName
      }
    },
    bgBtnClick() {},
    studentAnswer(data) {
      this.visible = true
      this.needData.moduleId = data.moduleId
      this.needData.modType = data.modType
      this.getRightAnswer('student')
    },
    rightAnswer(data) {
      this.visible = true
      this.needData.moduleId = data.moduleId
      this.needData.modType = data.modType
      this.getRightAnswer()
    },
    async getRightAnswer(type) {
      const url = type === 'student' ? `${Urls.getStuAnswer}` : `${Urls.getRightAnswer}`
      const params = parseParam({
        moduleId: this.needData.moduleId,
        modType: this.needData.modType,
      })
      const res = await this.$http.post(`${url}&${params}`)
      console.log(res)
      if (res) {
        if (this.needData.modType === '7') {
          this.invoiceData = res.data
        } else if (this.needData.modType === '1' || this.needData.modType === '8') {
          this.rightList = res.data
          console.log(this.rightList)
        }
        if (this.invoiceData !== undefined || this.rightList !== undefined) {
          if (this.invoiceData.isErrorTaxClass !== undefined) {
            // this.isErrorTaxClass.emit(this.invoiceData.isErrorTaxClass)
          } else if (this.rightList.isErrorTaxClass !== undefined) {
            // this.isErrorTaxClass.emit(this.rightList.isErrorTaxClass)
          }
        }
        this.bList = res.data.B
        this.allMoney = Number(this.rightList.totalTaxPays) + Number(this.rightList.totalGoodsPrices)
      }
    },
    handleCancel() {
      this.visible = false
      this.rightList = {}
      this.bList = []
      // this.needData = { moduleId: '', modType: '', domainName: '' }
    },
  },
}
</script>

<style lang="less" scoped>
.answer-list {
  display: flex;
  height: 35px;
  border-bottom: 1px solid black;
}

.answer-list-left {
  flex: 1;
  border-right: 1px solid black;
  align-items: center;
  display: flex;
  justify-content: center;
  font-weight: bold;
}

.answer-list-right {
  flex: 9;
  padding-left: 10px;
  display: flex;

  align-items: center;
}
.answer-centent {
  width: 1000px;
  margin: 0 auto;
  border: 1px solid black;
}
.taskModal {
  position: absolute;
  z-index: 99999;
  width: 800px;
  height: 500px;
  box-sizing: border-box;
  background: #fff;
  border-radius: 5px;
  border: 2px solid #335774;
  bottom: 1px;
  left: 1px;
}
.minTaskModal {
  position: absolute;
  z-index: 99999;
  width: 320px;
  height: 40px;
  box-sizing: border-box;
  /* background: #fff; */
  border-radius: 5px;
  border: 5px solid #335774;
  bottom: 20px;
  left: 0px;
}

.bgzl-header {
  background: #335774;
  height: 35px;
  width: 100%;
  display: -webkit-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.bgzl-header .bgzl-title {
  display: -webkit-box;
  display: flex;
}
.bgzl-header .bgzl-title img {
  display: block;
  width: 20px;
  height: 20px;
}
.bgzl-header .bgzl-title .title {
  color: #fff;
  font-size: 12px;
  line-height: 20px;
  padding-left: 10px;
}
.bgzl-header .btn-g {
  background: #335774;
  border: none;
  color: #fff;
}
.bgzl-modal-max {
  transform: none !important;
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  height: 100% !important;
}
.error {
  // color: red;
  background-color: red;
}
</style>
<style lang="less" scoped>
// 发票样式专用，可优化为一个组件
.normal {
  .main-cont {
    display: flex;
    flex: 1;
    justify-content: space-around;
    .cont-invoice {
      &.pt {
        background-image: url('~@/assets/invoice-pt.png');
      }
      &.zy {
        background-image: url('~@/assets/invoice-zy.png');
      }
      &.dz {
        background-image: url('~@/assets/invoice-dzpt.png');
      }
      width: 1137px;
      height: 665px;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      margin: 5px;
      position: relative;
      .invoice-header {
        height: 78px;
        display: block;
        font-size: 29px;
        font-family: '宋体';
        font-weight: 700;
        border: none;
        color: #9d5426;
        position: relative;
        span {
          position: absolute;
          top: 38px;
        }
      }
      .invoice-no {
        margin-top: 15px;
        .version {
          text-align: right;
          margin-right: 109px;
          color: #c7c7c7;
        }
        .code {
          margin-left: 164px;
        }
        .number {
          // margin-left: 69px;
          position: absolute;
          left: 362px;
        }
        .date {
          display: inline-block;
          // margin-left: 503px;
          position: absolute;
          left: 944px;
        }
      }
      .invoice-buyer {
        input[type='text'] {
          border: 1px solid #a2ddfb;
          display: block;
        }
        .left {
          margin-left: 236px;
          margin-top: 7px;
          display: inline-block;
          input {
            width: 400px;
          }
        }
        .right {
          // display: inline-block;
          // margin-left: 27px;
          height: 100px;
          position: absolute;
          top: 141px;
          left: 638px;
          width: 404px;
          background-color: #fff;
        }
      }
      .invoice-table {
        width: 83.4%;
        margin-left: 8.3%;
        margin-top: 3px;
        .tab {
          display: flex;
          height: 21px;
          > div {
            border: 1px solid #a2ddfb;
            box-sizing: border-box;
            width: 100%;
          }
        }
        .table-header {
          text-align: center;
          background-color: #cee3f4;
        }
        .table-content {
          input[type='text'],
          input[type='number'],
          select {
            width: 100%;
            height: 100%;
            border: none;
            background-color: transparent;
          }
        }
      }
      .invoice-sum {
        margin-top: 15px;
        font-weight: 500;
      }
      .invoice-taxsum {
        height: 36px;
        line-height: 36px;
        font-weight: 500;
      }
      .invoice-saler {
        display: flex;
        input[type='text'] {
          border: 1px solid #a2ddfb;
          display: block;
          height: 23px;
        }
        .left {
          margin-left: 237px;
          margin-top: 2px;
          input {
            width: 400px;
          }
        }
        .right {
          margin-left: 27px;
          width: 380px;
          height: 95px;
          textarea {
            height: 100%;
            width: 100%;
            padding: 0;
          }
        }
      }
      .invoice-footer {
        display: flex;
        align-items: center;
        margin-top: 3px;
        .payee {
          margin-left: 187px;
        }
        .review {
          position: absolute;
          left: 442px;
          input {
            width: 150px;
          }
        }
        .billing {
          position: absolute;
          top: 604px;
          left: 664px;
        }
        input[type='text'] {
          border: 1px solid #a2ddfb;
        }
      }
    }
    .cont-op {
      display: flex;
      flex-direction: column;
      padding: 5px;
      justify-content: center;
      button {
        margin: 5px 0;
      }
    }
  }
}
.special {
  .main-cont {
    display: flex;
    flex: 1;
    justify-content: space-around;
    .cont-invoice {
      width: 1137px;
      height: 665px;
      background-image: url(~@/assets/credit-memo.png);
      background-repeat: no-repeat;
      background-size: 100% 100%;
      margin: 5px;
      position: relative;
      .invoice-header {
        height: 78px;
        display: block;
        font-size: 29px;
        font-family: '宋体';
        font-weight: 700;
        border: none;
        color: #9d5426;
        position: relative;
        span {
          position: absolute;
          left: 444px;
          top: 38px;
        }
      }
      .invoice-no {
        margin-top: 8px;
        .applyer {
          position: absolute;
          left: 427px;
        }
        .number {
          // margin-left: 69px;
          position: absolute;
          left: 652px;
        }
        .date {
          display: inline-block;
          // margin-left: 503px;
          position: absolute;
          left: 156px;
        }
      }
      .invoice-buyer {
        margin-top: 40px;
        position: relative;
        input[type='text'] {
          border: 1px solid #a2ddfb;
          display: block;
        }
        .left {
          margin-left: 236px;
          display: inline-block;
          position: relative;
          height: 77px;
          .enterpriseName {
            position: absolute;
            top: 7px;
          }
          .enterpriseTaxPayerId {
            position: absolute;
            top: 46px;
          }
          input {
            width: 327px;
          }
        }
        .right {
          display: inline-block;
          margin-left: 300px;
          left: 734px;
          .buyerName {
            position: absolute;
            left: 737px;
            top: 9px;
          }
          .buyerTaxPayerId {
            position: absolute;
            left: 737px;
            top: 48px;
          }
        }
      }
      .invoice-table {
        width: 88.9%;
        margin-left: 5.6%;
        min-height: 241px;
        .tab {
          display: flex;
          height: 26.6px;
          > div {
            border: 1px solid #a2ddfb;
            box-sizing: border-box;
            width: 100%;
          }
        }
        .table-header {
          text-align: center;
          background-color: #cee3f4;
        }
        .table-content {
          input[type='text'],
          input[type='number'],
          select {
            width: 100%;
            height: 100%;
            border: none;
            background-color: transparent;
          }
        }
      }
      .invoice-sum {
        font-weight: 500;
        height: 28px;
        position: relative;
      }
      .invoice-taxsum {
        height: 36px;
        line-height: 36px;
        font-weight: 500;
      }
      .invoice-saler {
        display: flex;
        height: 158px;
        .left {
          margin-left: 114px;
          margin-top: 16px;
        }
        .right {
          margin-left: 260px;
          width: 380px;
          height: 95px;
          > div {
            height: 32px;
            line-height: 32px;
          }
        }
      }
      .invoice-footer {
        display: flex;
        align-items: center;
        margin-top: 3px;
        .payee {
          margin-left: 187px;
        }
        .review {
          margin-left: 87px;
        }
        .billing {
          margin-left: 48px;
        }
        input[type='text'] {
          border: 1px solid #a2ddfb;
        }
      }
    }
    .cont-op {
      display: flex;
      flex-direction: column;
      padding: 5px;
      justify-content: center;
      button {
        margin: 5px 0;
      }
    }
  }
}
</style>
